import pathfinder from '@fiverr-private/pathfinder';

export const getStartedUrl = () =>
    pathfinder('logo_maker_brief_page_logo_maker_brief_step_name', {
        step_name: 'logo_name',
    });
